import moment, { Moment } from 'moment';

/** Calendar date from ISO or YYYY-MM-DD without timezone day shift. */
export function getCalendarDateString(dateValue: string): string {
	const parsed = moment.parseZone(dateValue);
	if (
		parsed.isValid() &&
		parsed.utcOffset() === 0 &&
		parsed.utc().format('HH:mm:ss.SSS') === '00:00:00.000'
	) {
		return parsed.utc().format('YYYY-MM-DD');
	}

	return moment(dateValue).format('YYYY-MM-DD');
}

function combineDateAndTimeOnCalendarDay(
	dateValue: string,
	timeMoment: Moment,
): Moment {
	const t = moment.isMoment(timeMoment) ? timeMoment : moment(timeMoment);
	const datePart = getCalendarDateString(dateValue);

	return moment(`${datePart} ${t.format('HH:mm')}`, 'YYYY-MM-DD HH:mm', true);
}

export function combineExamDateAndTime(
	dateValue: string,
	timeMoment: Moment,
): string {
	return combineDateAndTimeOnCalendarDay(dateValue, timeMoment).toISOString();
}

/** Both times apply to the same exam date; cross-midnight ranges are not supported. */
export function isExamEndTimeAfterStartTime(
	dateValue: string,
	timeFrom: Moment,
	timeTo: Moment,
): boolean {
	const from = combineDateAndTimeOnCalendarDay(dateValue, timeFrom);
	const to = combineDateAndTimeOnCalendarDay(dateValue, timeTo);

	return to.isAfter(from);
}
